var userMap = {
  authData: 'authData',
  business_entity_name: 'businessEntityName',
  business_trading_name: 'businessTradingName',
  company_address: 'businessAddress',
  created_at: 'createdAt',
  device_platform: 'devicePlatform',
  device_type_id: 'deviceTypeId',
  dob: 'dateOfBirth',
  email: 'emailAddress',
  first_name: 'firstName',
  hubspotIDToken: 'hubspotIDToken',
  id: 'id',
  marketing: 'marketing',
  marketing_readable: 'marketingReadable',
  name: 'name',
  phone_number: 'phoneNumber',
  send_as_name: 'sendAsName',
  surname: 'lastName',
  tags: 'tags',
  type: 'type',
  type_readable: 'typeReadable',
  updated_at: 'updatedAt',
  username: 'username',
  verified_email: 'verifiedEmail',
  verified_phone_number: 'verifiedPhoneNumber'
};
export default userMap;